module.exports = __webpack_public_path__ + "img/form-title.d7a896dc.png";